import LegalStubPage from "./LegalStubPage";

export default function PrivacyPage() {
  return <LegalStubPage title="Privacy Policy" />;
}
